module.exports = __webpack_public_path__ + "img/s4Model2.dd8422bf.webp";